<template>
  <div>
    <!--begin::Content header-->
    
    <!--end::Content header-->
      <!--begin::Form-->
      <b-form class="form-signin d-flex align-items-stretch flex-column" @submit.stop.prevent="onSubmit">
        <div class="text-center mb-2">
          <img class="mb-2" src="media/img/femsa.png" alt="" width="120">
          <h3 class="mb-0">Iniciar Sesión</h3>
        <span>Inicia sesión con tu cuenta empresa</span>
        </div>

        <div
          role="alert" v-show="errors.length>0"
          v-bind:class="{ show: errors.length }"
          class="alert alert-danger"
        >
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error }}
          </div>
        </div>
        <div class="form-label-group">
          <label for="inputRut">Rut Empresa</label>
          <b-form-input
            autocomplete="off"
            class="form-control"
            id="rutEmpresa"
            name="rutEmpresa"
            placeholder="Ingrese Rut de Empresa"
            v-model="$v.form.rutEmpresa.$model"
            :state="validateState('rutEmpresa')"
            aria-describedby="input-rutEmpresa-live-feedback" autofocus
          ></b-form-input>
          <b-form-invalid-feedback id="input-rutEmpresa-live-feedback">
            Rut empresa es requerido y debe ser valido.
          </b-form-invalid-feedback>
        </div>
        <div class="form-label-group">
          <label for="inputRut">Rut Usuario</label>
          <b-form-input
            class="form-control"
            id="example-input-1"
            autocomplete="off"
            name="example-input-1"
            placeholder="Ingrese Rut del Usuario"
            v-model="$v.form.rut.$model"
            :state="validateState('rut')"
            aria-describedby="input-1-live-feedback" autofocus
          ></b-form-input>
          <b-form-invalid-feedback id="input-1-live-feedback">
            Rut es requerido y debe ser valido.
          </b-form-invalid-feedback>
        </div>

        <div class="form-label-group">
          <label for="inputPassword">Contraseña</label>
          <b-form-input
            class="form-control"
            type="password"
            id="example-input-2"
            name="example-input-2"
            placeholder="Ingrese su Contraseña"
            v-model="$v.form.password.$model"
            :state="validateState('password')"
            autocomplete="false"
            aria-describedby="input-2-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-2-live-feedback">
            Contraseña es requerida.
          </b-form-invalid-feedback>
          </div>
       
        <!--begin::Action-->
         <button
            ref="kt_login_signin_submit"
            class="btn btn-primary align-self-center"
          >
            Ingresar
          </button>

        <p class="mt-3 mb-3 text-muted text-center">
          <a
            href="#"
            v-on:click="$router.push('recovery')"
            class="text-dark-60 text-hover-primary my-3 mr-2"
            id="kt_login_forgot"
          >
           ¿Has olvidado tu contraseña?
          </a>
        </p>
        <div 
          class="text-right mb-lg-0 flex-column-auto justify-content-center py-2 px-0"
        >
          <span class="font-weight-bold font-size-3 text-dark-60">
            ¿Aún no tienes una cuenta?
          </span>
          <router-link
            class="font-weight-bold font-size-3 ml-2"
            :to="{ name: 'register' }"
          >
          !Regístrate!
          </router-link>
        </div>
        <!--end::Action-->
        <div><v-btn
                color="pink"
                
                
                dark
                class="v-btn--example"
                @click="modalError=true"
              >
                ¿Tienes problemas?. Avísanos.
              </v-btn></div>
      </b-form>
      
      <!--end::Form-->
      <b-modal id="sidebar-right" hide-footer v-model="modalError" title="Declarar Problema">
        <div class="px-3 py-2">
          <p>
           ¿Se ha presentado un error?<br/>
           Por favor informanos a través de este formulario y lo resolveremos a la brevedad.
          </p>
          <div class="form-label-group">
            <label for="nombre">Por favor indiquenos su nombre o Rut de empresa</label>
            <b-form-input
              autocomplete="off"
              class="form-control"
              id="nombre"
              name="nombre"
              placeholder="Ingrese nombre o Rut de empresa"
              v-model="nombreError"
              autofocus
            ></b-form-input>
          </div>
          <div class="form-label-group">
            <label for="titulo">Principal Problema</label>
            <b-form-input
              autocomplete="off"
              class="form-control"
              id="titulo"
              name="titulo"
              placeholder="Ingrese el error presentado"
              v-model="tituloError"
              autofocus
            ></b-form-input>
          </div>
          <div class="form-label-group">
            <label for="titulo">Describe brevemente el problema</label>
            <b-form-textarea
                id="textarea"
                v-model="descripcionError"
                placeholder="Describe el problema"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
          </div>
          <button @click="sendTask"
            class="btn btn-primary align-self-center"
          >
            Notificar
          </button>
        </div>
      </b-modal>
      
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import { LOGIN, LOGOUT } from "@/core/services/store/auth.module";
import { CREATE_TASK_JIRA } from "@/core/services/store/jira.module";

import {rutEsValido} from "@/core/validators/rut.js"
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { validationMixin } from "vuelidate";
import { minLength, required } from "vuelidate/lib/validators";
Vue.use(VueReCaptcha, { siteKey: '6LfhajsaAAAAAOmttdUAzgYkTvd2HxXUgmT5KTT8' })



export default {
  mixins: [validationMixin],
  name: "login",
  data() {
    return {
      // Remove this dummy login info
      form: {
        rutEmpresa: "",//"96776000-5",
        rut: "",//"96776000-5",
        password: "",//"654321"
      },
      nombreError:null,
      tituloError:null,
      descripcionError:null,
      modalError:false,
      fab: false,
      hidden: false,
      tabs: null,
    };
  },
  mounted(){
    this.$store.dispatch(LOGOUT);
  },
  validations: {
    form: {
      rutEmpresa: {
        required,
        rutEsValido
      },
      rut: {
        required,
        rutEsValido
      },
      password: {
        required,
        minLength: minLength(3)
      }
    }
  },
  methods: {
    sendTask() {
      if (this.tituloError==null || this.tituloError=='') {
        return;
      }
      const descripcionError = `Declara Error: ${this.nombreError}\n\t ${this.descripcionError}`;
      this.$store
        .dispatch(CREATE_TASK_JIRA, { project:'', module:'', title:this.tituloError, description:descripcionError })
        .then(() => {
          this.modalError = false;
          this.nombreError=null;
          this.tituloError=null;
          this.descripcionError=null;
        });
    },
    async recaptcha() {
      await this.$recaptchaLoaded()   
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        rut: null,
        password: null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    async onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      const rutEmpresa = this.$v.form.rutEmpresa.$model;
      const rut = this.$v.form.rut.$model;
      const contrasena = this.$v.form.password.$model;

      // clear existing errors
      this.$store.dispatch(LOGOUT);

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      const token = await this.$recaptcha('login')
      
      // dummy delay
      setTimeout(() => {
        // send login request
        this.$store
          .dispatch(LOGIN, { rutEmpresa, rut, contrasena, token })
          // go to which page after successfully login
          .then((response) => {
            if(response.bloqueado){
              this.$router.push({ name: "block" });
            } else if(response.debeCambiarClave){
              this.$router.push({ name: "changePassword", params: { token: response.tokenUsuario }  });
            } else {
              this.$router.push({ name: "proveedor" });
            }
          });

        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
      }, 500);
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    })
  }
};
</script>
